import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './abt_types.2';

export function metadata(variable: types.MetadataVariables, options?: GqlRequestOptions) {
  const query = 'query Metadata($uuid: String) { metadata(ui: $uuid, platform: "", data_version: 7) { feature_list } }';
  return gql_request<types.Metadata, types.MetadataVariables>('Metadata', query, variable, { use_consumer: true, ...options });
}
